import * as React from 'react'
import SelectJobnumbers from './SelectJobnumbers'
import DepartmentLinks from './DepartmentLinks'
import DepartmentWorktypes from './DepartmentWorktypes'
import WeeklistDefaultDepartmentsSelect from './WeeklistDefaultDepartmentsSelect'
import CommonContext, { CurrentUserType } from '../../CommonContext'

interface EditCurrentUserProps {
  userJobnumbers: Array<any>
  departments?: Array<any>
  availableWorktypes?: Array<any>
  availableDepartments: Array<any>
  currentUser: CurrentUserType
}
export default function EditCurrentUser(props: EditCurrentUserProps) {
  const { userJobnumbers, departments, availableWorktypes, availableDepartments, currentUser } = props
  const dictionaries = { availableWorktypes, currentUser }

  return (
    <CommonContext.Provider value={dictionaries}>
      <div>
        <div className="form-group">
          <label htmlFor="car_registration">Bil registreringsnummer:</label>
          <input
            type="text"
            className="form-control"
            id="car_registration"
            name="user[car_registration]"
            defaultValue={currentUser.car_registration || ''}
            placeholder="Indtast bil registreringsnummer"
          />
          <small className="form-text text-muted">Dette vil blive brugt til ladeplads booking.</small>
        </div>

        <WeeklistDefaultDepartmentsSelect
          availableDepartments={availableDepartments}
          currentUser={currentUser}
          name="user[weeklist_default_department_ids][]"
          inputId="weeklist-default-departments"
        />

        <SelectJobnumbers
          defaultJobnumbers={userJobnumbers}
          inputName="user[user_jobnumbers_attributes]"
          label="Bruger specifikke Sags-ID numre:"
          selectId="edit-user-jobnumber-select"
        />

        {departments &&
          departments.map(department => {
            const elementId = `edit-department-jobnumber-select-${department.id}`
            const { jobnumbers } = department
            return (
              <div className="mt-4" key={department.id}>
                <SelectJobnumbers
                  defaultJobnumbers={jobnumbers}
                  inputName={`department_jobnumber_ids[${department.id}]`}
                  label={`Sagsnumre til afdeling "${department.name}":`}
                  selectId={elementId}
                />
              </div>
            )
          })}

        {departments && <h2 className="mt-4">Links for departments</h2>}
        {departments && departments.map(department => <DepartmentLinks department={department} key={department.id} />)}
        {departments && <h2 className="mt-4">Worktypes for departments</h2>}
        {departments && departments.map(department => <DepartmentWorktypes department={department} key={department.id} />)}
      </div>
    </CommonContext.Provider>
  )
}
